"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("../../lib/constants");

var DEFAULTS = {
  favoriteBlog: null,
  status: _constants.RequestStatus.UNINITIALIZED
};

var FavoriteBlog = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(FavoriteBlog, _Record);

  function FavoriteBlog() {
    (0, _classCallCheck2.default)(this, FavoriteBlog);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FavoriteBlog).apply(this, arguments));
  }

  (0, _createClass2.default)(FavoriteBlog, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new FavoriteBlog({
        favoriteBlog: data.lastViewedBlog || data.favoriteBlog,
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return FavoriteBlog;
}((0, _immutable.Record)(DEFAULTS));

exports.default = FavoriteBlog;
module.exports = exports.default;